import React, {useEffect, useMemo, useState} from 'react'
import {Row, Col, Form, Card, Button, Divider, Checkbox, Spin} from 'antd'
import { connect } from 'react-redux'

import InputField from 'components/InputField'
import TextAreaField from 'components/TextArea'
import SelectField from 'components/SelectField'
import FileUpload from 'components/fileUpload'

import {
    SaveIco,
    SaveBlueIco,
    RefreshIco, SearchIco, MinusSmallIco, PlusSmallIco, CheckGreenIco, CancelRedIco, SuccessIconLimit, ErrorLimitIcon,
    EroorIco,
} from "../../../../../modules/CustomIcons"

import './index.scss'
import '../../transfer.scss'
import {OWNACCOUNT} from "constants/constants";
import {Account, getAccounts, getSavedDocuments} from "../../../../services/account";
import {SelectOptions} from "../../../../services/form";
import {getCurrentCompany, getUserData} from "../../../../services/user";
import {
    checkAmountForRequest,
    fillCurrentForm,
    fillCurrentFormTemplate,
    financial,
    resetForm
} from "../../../../services/helper";
import AmountField from "components/AmountField";
import NextModal from "components/NextModal";
import TemplatePopup from "components/TemplatePopup";
import {getCustomerCommission} from "../../../../services/Customers/Commission";
import SaveAsTemplate from "components/SaveAsTemplate";
import {useLocation} from "react-router-dom";
import {setIbanNumber } from "../../../../store/actions/accountStatement";
import { useActions } from 'hooks/useActions'
import { useTranslation } from 'react-i18next'
import {
    BankCodes,
    ClassificationCodes,
    getClassificationCodes,
    getTeskilatCodesByFilter
} from "../../../../services/moneytransfer";
import LimitsModal from "components/LimitsModal/LimitsModal";
import {
    benefBankAccCheck,
    checkLimit,
    cutOffService,
    getInfoByAlias, IpsNewTransfer,
    receiverDetail
} from "../../../../services/Transfers/transfers";
import {
    getIpsVatDocumentNumber
} from "../../../../services/Accounts/DocumentNumber";
import FullScreenLoading from "components/FullScreenLoading";
import {deleteFileById} from "../../../../services/Transfers/Files";
import debounce from 'lodash.debounce'




const Edv: React.FC<any> = ({ ibanNumber,ownProps }) => {
    const {t} = useTranslation()
    const language = localStorage.getItem("i18nextLng")
    let messageCutOff = "";
    let alertmessage = ''
    const modalDataInitial={
        modalTitle : 'AniPay -  ƏDV',
        groups: [
            {
                title: false,
                data: []
            }
        ],
        note : "",
        pdfFiles : [],
        buttons : [
            {save : true},
            {sign : true},
            {approve : true},
            {send : true}
        ],
        alertText: "",
    }

    const [visible, setVisible] = useState(false);
    const [aliasStatus, setAliasStatus] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [inputPlaceholder, setInputPlaceholder] = useState('');
    const [allAccounts, setAllAccounts]=useState<Account[]>();
    const [fromSelectOptions, setFromSelectOptions]=useState<SelectOptions[]>();
    const [levelCodeOptions, setLevelCodeOptions]=useState<SelectOptions[]>();
    const [ibankRef, setIbankRef] = useState<string>('');
    const [retryRequest, setRetryRequest]=useState(null);

    const [fromBranch, setFromBranch]=useState<Account>();
    const [nextModalVisible, setNextModalVisible] = useState(false);
    const [templatePopupVisible, setTemplatePopupVisible] = useState(false);
    const [saveAsTemplatePopupVisible, setSaveAsTemplatePopupVisible] = useState<boolean>(false);
    const [bankCodes, setBankCodes]=useState<ClassificationCodes>();
    const [allBankCodes, setAllBankCodes]=useState<ClassificationCodes>();
    const [formFields, setFormFields]=useState({});
    const [commissionLoading, setCommissionLoading]=useState(false);
    const [commissionAmount, setCommissionAmount]=useState('');
    const [commissionAmountModal, setCommissionAmountModal]=useState('');
    const [amountModal,setAmountModal] = useState('')
    const [isDisabled,setIsDisabled] = useState(true)
    const [custAcc,setcustAcc] = useState('')
    const [statusLimit,setStatusLimit] = useState('')
    const [documentNo,setDocumentNo] = useState('')
    const [bankTaxId,setBankTaxId] = useState('')
    const [bankCorAcc,setBankCorAcc] = useState('')
    const [bankSwift,setBankSwift] = useState('')
    const [getbyAlias,setGetbyAlias] = useState('N')
    const [limitModal,setlimitModal] = useState(false)
    const [typeTransfer,setTypeTransfer] = useState('')
    const [amountTransfer,setAmountTransfer] = useState('')
    const [cariCount,setCariCount] = useState('')
    const [sendCariCount,setSentCariCount] = useState('')
    const [cariTotalAmount,setCariTotalAmount] = useState('')
    const [limitTotalAmount,setLimitTotalAmount] = useState('')
    const [nextModalNote,setNextModalNote] = useState('')
    const [modalNote,setModalNote] = useState('')
    const [modal2ndtitle,set2ndTitle]= useState('')
    const [currency,setCurrency] = useState('')
    const [alertText,setAlertText] = useState('')
    const [disabledSign,setdisabledSign] = useState(false)
    const [commCode,setCommCode] = useState('')
    const [classModalVisible, setClassModalVisible] = useState(false);
    const [message,setMessage]= useState('')
    const [loadingAccount, setLoadingAccount] = useState(false);
    const [loadinglimit,setLoadingLimit] = useState(false)
    const [getByTemp,setGetbyTemp] = useState("N")
    const [tempName,setTempName] =useState('')
    const [loadingData, setLoadingData] = useState(false);
    const [modalData, setModalData] = useState(modalDataInitial);
    const [form] = Form.useForm();
    const [fileList, setFileList] = useState([])
    const [fileUp, setFileUp] = useState<any[]>([])
    const location=useLocation();
    const { setIbanNumber } = useActions();
    const addOrEditPage = ownProps?.addOrEditPage || false;

    var limitMessage =''

    const modalDataLimit = {
        modalTitle : t('businessCards.limits'),
        note:modalNote,
        type:statusLimit,
        icon:statusLimit==="success"?<SuccessIconLimit/>:<ErrorLimitIcon/>,
        groups : [
            {
                title : false,
                tableHasBorderBottom : true,
                data : [
                    {
                        label : t("transfers.transfersType"),
                        value : typeTransfer
                    },
                    {
                        label :  t("transfers.transfersAmount"),
                        value : amountModal
                    },
                    {
                        label : t("transfers.comAmount"),
                        value : commissionAmountModal
                    }
                ]
            },
            {
                title : modal2ndtitle,
                tableHasBorderBottom2 : false,
                tableHasMarginBottom : false,
                data : [
                    {
                        label : t('transfers.transactionsNum'),
                        value : sendCariCount
                    },
                    {
                        label :  t('transfers.transactionsTotNum'),
                        value : amountTransfer
                    },
                    {
                        label : t('transfers.allowableToSendNum'),
                        value : cariCount
                    },
                    {
                        label : t('transfers.allowableToSendAmount'),
                        value : cariTotalAmount
                    },
                    {
                        label : t('transfers.totalLimitTransAmount'),
                        value : limitTotalAmount
                    }
                ]
            },

        ],
        pdfFiles : [],
        buttons : [
            {save : true},
            {sign : true},
            {approve : true},
            {send : true}
        ]
    }

    const fetchData = async () => {
        setLoadingAccount(true);
        const data = await getAccounts(getCurrentCompany());
        const new_data = data.filter(row=>row.CCY_NAME == "AZN")

        let temp_data=[];

        for (let row of new_data ){
            if(row.STATUS !== "0") {

                temp_data.push({
                    label: row.NICKNAME ? row.NICKNAME : row.IBAN,
                    value: row.ACCOUNT_NO,
                    extra: `${financial(row.BALANCE_LC)} ${row.CCY_NAME}`
                });

            }
            // @ts-ignore

        }


        setAllAccounts(new_data);
        setFromSelectOptions(old_data => temp_data);

        /**/
        if (location?.state?.trnData){
            fillCurrentForm(form, location.state.trnData)
        }
        setLoadingAccount(false);
    };

    useEffect(() => {
        if (location.state?.data)
            loadData()
        else if (location.state?.trnData)
            loadDataTemplate2(location.state)
        else {
            fetchData();

        }

    }, [location.state]);

    const loadData = async () => {
        // setDisableCode(true)
        const pdf = await getSavedDocuments(location.state?.data['ibankRef'])
        setFileList(pdf.data?.fileDetailsList)
        setLoadingData(true)
        // load Account
        setLoadingAccount(true);
        const data = await getAccounts(getCurrentCompany());
        let temp_data = [];
        for (let row of data) {
            if (row.STATUS !== "0") {
                if (row.CCY_NAME.toString().toLowerCase() !== 'azn') {
                    continue;
                }

                // @ts-ignore
                temp_data.push({
                    label: row.NICKNAME ? row.NICKNAME : row.IBAN,
                    value: row.IBAN,
                    extra: `${financial(row.BALANCE_LC)} ${row.CCY_NAME}`
                });
            }
        }
        setAllAccounts(data.filter(row => row.STATUS !== "0"));
        setFromSelectOptions(old_data => temp_data);
        setLoadingAccount(false);
        if(location.state?.edit)
            setIbankRef(location.state?.data['ibankRef'])
        // const pdf = await getSavedDocuments(location.state?.data['ibankRef'])



        // CUSTACC
        const findAccount = data?.find(row => row.IBAN == location.state?.data['CUSTACC']);
        if (findAccount !== undefined) {
            setIsDisabled(false)
            setFromBranch(findAccount);
            if ((form.getFieldValue('document_no') === "" || form.getFieldValue('document_no') === undefined) && location.state?.edit === undefined) {
                updateDocumentNumber();
            } else if (location.state?.edit) {
                form.setFieldsValue({
                    'document_no': location.state?.data['PMTCUSTID']
                });
            }
            form.setFieldsValue({
                'CUSTACC': findAccount.IBAN
            });
        }

            //BENEFACC
            if (location.state?.data['BENEFACC'] !== undefined && location.state?.data['BENEFACC'] !== null) {
                form.setFieldsValue({
                    'BENEFACC':location.state?.data['BENEFACC'],
                    'BENEFNAME':location.state?.data['BENEFNAME'],
                    'BENEFTAXID':location.state?.data['BENEFTAXID'],
                    // 'BENEFBANKCODE':location.state?.data['BENEFBANKCODE'],
                    // 'BENEFBANKNAME':location.state?.data['BENEFBANKNAME'],
                })
        }



        // AMOUNT
        form.setFieldsValue({
            'AMOUNT': checkAmountForRequest(location.state?.data['PMTAMOUNT'])
        });
        // AMOUNT
        form.setFieldsValue({
            'PMTDET': location.state?.data['PMTDET']
        });

        form.setFieldsValue({
            'NOTE': location.state?.data['NOTE']
        });
        // AMOUNT
        form.setFieldsValue({
            'INFOTOBENEF': location.state?.data['INFOTOBENEF']
        });

        setcustAcc(findAccount?.IBAN)

        // COMISSION
        let valueA = checkAmountForRequest(location.state?.data['PMTAMOUNT']);

        if (!isNaN(valueA)) {
            setCommissionLoading(true);
            setIsDisabled(true)
            getCustomerCommission({
                PAYMENT_TYPE: "PV",
                CIF: getCurrentCompany().customerNo,
                CUSTACC: findAccount?.IBAN,
                AMOUNT: valueA,
                CUR: findAccount?.CCY_NAME,
                BENEFBANKCODE: location.state?.data['BENEFBANKCODE'],
                BENEFACC: location.state?.data['BENEFACC'],
                BENEFTAXID: location.state?.data['BENEFTAXID'],
                PMTDET: location.state?.data['PMTDET'].length > 70 ? location.state?.data['PMTDET'].substring(0,70) : location.state?.data['PMTDET'],

            }).then(res => {
                setCommissionLoading(false);

                form.setFieldsValue({
                    'COMMAMOUNT': res.COM_AMOUNT ?? ''
                });
                setIsDisabled(false)
                setCommCode(res.CommCode ?? '')
                setCommissionAmount(old_value => res.COM_AMOUNT ?? '')
            })
        } else {
            setCommissionLoading(false);

            form.setFieldsValue({
                'COMMAMOUNT': ''
            });

            setCommissionAmount(old_value => '');
        }
        setLoadingData(false)
        form.setFieldsValue({
            'BENEFACC':'AZ48CTRE00000000000000014001'
        })
    }
    const getSelectedFromBranch = async(value:any) => {
        const findAccount=allAccounts?.find(row => row.ACCOUNT_NO==value || row.IBAN === value);
        setFromBranch(findAccount);
        setcustAcc(findAccount?.IBAN)
        if(findAccount !== undefined && findAccount !== null){
            setIsDisabled(false)
            const document_number = await getIpsVatDocumentNumber(getCurrentCompany());
            form.setFieldsValue({
                'document_no' : document_number
            });
            setDocumentNo(old_value => document_number)
        }
    }

    useEffect(() => {
        if(ibanNumber.iban && allAccounts){
        const findAccount=allAccounts?.find(row => row.IBAN==ibanNumber.iban);
        setFromBranch(findAccount);

        setIbanNumber({iban: undefined, ccy_name: undefined})
        }

      }, [ibanNumber, allAccounts])

    const submitHandler = async (args: any) => {
        let pdf_files = form.getFieldValue('pdf_files') ?? [];
        modalDataInitial.pdfFiles = [];
        await calculateCommission(args.AMOUNT);
        var res = await nextModalApi()
        if(res?.LIMITMSGSTAT === 'Success'){
            await checkBenefAcc()
        
        

        }else{
            setlimitModal(true)
        }
            if (pdf_files.length > 0) {

                for (let file of pdf_files) {
                    modalDataInitial.pdfFiles.push({
                        label: file.name,
                        file: file
                    })
                }
            }
            //@ts-ignore
            setModalData((old_data: any) => ({
                ...modalDataInitial,
                groups: [
                    {
                        title: false,
                        tableHasBorderBottom: true,
                        data: [
                            {
                                label: t("transfers.sender"),
                                value: getCurrentCompany().name
                            },
                            {
                                label: t("salary.documentNo"),
                                value: form.getFieldValue('document_no')
                            },
                            {
                                label: t("transfers.fromAccount"),
                                value: custAcc
                            }
                        ]
                    },
                    {
                        title: t("requisites.beneficiary"),
                        tableHasBorderBottom: true,
                        tableHasMarginBottom: true,
                        data: [
                            {
                                label: t("requisites.name"),
                                value: form.getFieldValue('BENEFNAME')
                            },
                            {
                                label: t("deposit.accountNumber"),
                                value: form.getFieldValue('BENEFACC')
                            },
                            {
                                label: t("requisites.taxID"),
                                value: form.getFieldValue('BENEFTAXID')
                            }
                        ]
                    },
                    {
                        title: t("requisites.beneficiaryBank"),
                        tableHasBorderBottom2: true,
                        tableHasMarginBottom: true,
                        data: [
                            {
                                label: t("requisites.code"),
                                value: '210027'
                            },
                            {
                                label: t("requisites.name"),
                                value: t("newTransfer.stateTreasuryAgencyDXA")
                            }
                        ]
                    },

                    {
                        title: false,
                        data: [
                            {
                                label: t("common.amount"),
                                value: form.getFieldValue('AMOUNT')
                            },
                            {
                                label: t("home.commission"),
                                value: form.getFieldValue('COMMAMOUNT')
                            },
                            {
                                label: t("accountStatement.paymentDetails"),
                                value: form.getFieldValue('PMTDET')
                            },
                            {
                                label: t("transfers.infoForBeneficiary"),
                                value: form.getFieldValue('INFOTOBENEF')
                            },
                            {
                                label: t("newTransfer.note"),
                                value: form.getFieldValue('NOTE')
                            }
                        ]
                    }
                ],
                note: messageCutOff,
                alertText: alertmessage,
            }));



    }
    const getFileList = (info : any) => {
        form.setFieldsValue({
            'pdf_files' : info.fileList
        });
    }
    const removeFile = (index:any)=>{
        const myNewFiles = [...fileList]
        myNewFiles.splice(index, 1);
        setFileList(myNewFiles)
    }
    const useDebouncedCommission = (calculateCommission: any) => {
      return useMemo(
        () =>
          debounce((value: string) => {
            if (value) {
              calculateCommission({ target: { value } });
            }
          }, 500),
        [calculateCommission]
      );
    };
    const calculateCommission = async (e: any) => {
  let value;

  if (e?.target !== undefined) {
    value = checkAmountForRequest(e.target.value);
  } else {
    value = checkAmountForRequest(e);
  }

  setIsDisabled(true);

  if (!isNaN(value)) {
    try {
      setCommissionLoading(true);

      const res = await getCustomerCommission({
        PAYMENT_TYPE: "PV",
        CIF: getCurrentCompany().customerNo,
        CUSTACC: fromBranch?.IBAN,
        AMOUNT: value,
        CUR: fromBranch?.CCY_NAME,
        BENEFBANKCODE: form.getFieldValue("BENEFBANKCODE"),
        BENEFACC: form.getFieldValue("BENEFACC"),
        BENEFTAXID: form.getFieldValue("BENEFTAXID"),
        PMTDET: form.getFieldValue("PMTDET"),
      });

      form.setFieldsValue({
        COMMAMOUNT: res.COM_AMOUNT,
      });

      setCommCode(res.CommCode);
      setCommissionAmount(res.COM_AMOUNT);
    } catch (error) {
      console.error("Commission fetch failed:", error);

      form.setFieldsValue({
        COMMAMOUNT: "",
      });
      setCommissionAmount("");
    } finally {
      setCommissionLoading(false);
      setIsDisabled(false);
    }
  } else {
    setCommissionLoading(false);
    form.setFieldsValue({
      COMMAMOUNT: "",
    });
    setCommissionAmount("");
  }
};

    const debouncedCommission = useDebouncedCommission(calculateCommission);
    const openSaveAsTemplateModal = () => {

        setSaveAsTemplatePopupVisible(old_data => false)

        form.validateFields().then(res => {
            setSaveAsTemplatePopupVisible(old_data => true)

        }).catch(err_input_list => {

        })
    }
    const updateParentComponentFormData = () => {
        if (ownProps?.getFormElements){
            ownProps?.getFormElements({form});
        }
    }
    const updateDocumentNumber = async () => {
        const document_number = await  getIpsVatDocumentNumber(getCurrentCompany());

        form.setFieldsValue({
            'document_no' : document_number
        });
        setDocumentNo(old_value => document_number)
    }
    const loadDataTemplate = async (tempData) => {
        setGetbyTemp('Y')
        setAliasStatus(false)
        setIsDisabled(true)
        setLoadingData(true)
        const docid = documentNo;
        form.resetFields();
        if (tempData?.trnData) {
            fillCurrentFormTemplate(form, tempData?.trnData)
            updateParentComponentFormData();
        }
        if (docid !== "" && docid !== undefined) {
            form.setFieldsValue({
                'PMTCUSTID': docid
            });
            setDocumentNo(old_value => docid)
        }
        // CUSTACC
        const findAccount = allAccounts?.find(row => row.IBAN == tempData?.trnData.CUSTACC);
        if (findAccount !== undefined) {
            setIsDisabled(false)
            setFromBranch(findAccount);
            // if (docid === "" || docid === undefined) {
                updateDocumentNumber();
            // }

        }
        form.setFieldsValue({
            'CUSTACC': tempData?.trnData.CUSTACC
        });
        // AMOUNT
        form.setFieldsValue({
            'AMOUNT': checkAmountForRequest(tempData?.trnData.AMOUNT)
        });
        // PMTDET
        form.setFieldsValue({
            'PMTDET': tempData?.trnData.PMTDET.length > 70 ?  tempData?.trnData.PMTDET.substring(0,70) : tempData?.trnData.PMTDET
        });
        form.setFieldsValue({
            'NOTE': tempData?.trnData.NOTE
        });
        // AMOUNT
        form.setFieldsValue({
            'INFOTOBENEF': tempData?.trnData.INFOTOBENEF
        });
        // COMISSION
        let valueA = checkAmountForRequest(tempData?.trnData.AMOUNT);
        // ALIASTYPE


        setTempName(tempData?.templateName)
        setcustAcc(findAccount?.IBAN)

        if (!isNaN(valueA)) {
            setCommissionLoading(true);
            setIsDisabled(true)
            getCustomerCommission({
                PAYMENT_TYPE: "PV",
                CIF: getCurrentCompany().customerNo,
                CUSTACC: findAccount?.IBAN,
                AMOUNT: valueA,
                CUR: findAccount?.CCY_NAME,
                BENEFBANKCODE: tempData?.trnData.BENEFBANKCODE,
                BENEFACC: tempData?.trnData.BENEFACC,
                BENEFTAXID: tempData?.trnData.BENEFTAXID,
                PMTDET: tempData?.trnData.PMTDET.length > 70 ?  tempData?.trnData.PMTDET.substring(0,70) : tempData?.trnData.PMTDET,

            }).then(res => {
                setCommissionLoading(false);

                form.setFieldsValue({
                    'COMMAMOUNT': res.COM_AMOUNT ?? ''
                });
                setCommCode(res.CommCode ?? '')
                setIsDisabled(false)
                setCommissionAmount(old_value => res.COM_AMOUNT ?? '')
            })
        } else {
            setCommissionLoading(false);

            form.setFieldsValue({
                'COMMAMOUNT': ''
            });

            setCommissionAmount(old_value => '');
        }

        // BENEFBANKCODE
        form.setFieldsValue({
            'BENEFBANKCODE': '210005'
        });

        // BENEFBANKNAME
        form.setFieldsValue({
            'BENEFBANKNAME': t("newTransfer.stateTreasuryAgencyVAT")
        });
        form.setFieldsValue({
            'BENEFACC':'AZ48CTRE00000000000000014001'
        })
        setLoadingData(false)

    }

    const loadDataTemplate2 = async (tempData) => {
        setGetbyTemp('Y')
        setFileUp(tempData.trnData?.pdf_files);
        setLoadingData(true)
        // load Account
        setLoadingAccount(true);
        const data = await getAccounts(getCurrentCompany());
        let temp_data = [];
        for (let row of data) {
            if (row.STATUS !== "0") {
                if (row.CCY_NAME.toString().toLowerCase() !== 'azn') {
                    continue;
                }

                // @ts-ignore
                temp_data.push({
                    label: row.NICKNAME ? row.NICKNAME : row.IBAN,
                    value: row.IBAN,
                    extra: `${financial(row.BALANCE_LC)} ${row.CCY_NAME}`
                });
            }
        }
        setAllAccounts(data.filter(row => row.STATUS !== "0"));
        setFromSelectOptions(old_data => temp_data);
        setLoadingAccount(false);


        // CUSTACC

        const findAccount = data?.find(row => row.IBAN === tempData?.trnData.CUSTACC || row.ACCOUNT_NO === tempData?.trnData.CUSTACC  );

        if (findAccount !== undefined) {
            setIsDisabled(false)
            setFromBranch(findAccount);
            // if (form.getFieldValue('PMTID') === "" || form.getFieldValue('PMTID') === undefined) {
                updateDocumentNumber();
            // }
            form.setFieldsValue({
                'CUSTACC': findAccount?.IBAN
            });
        }
        setcustAcc(findAccount?.IBAN)
        // BENEFACC

        // if (tempData?.trnData.BENEFACC !== undefined && tempData?.trnData.BENEFACC !== null) {
        //     const dataBENEFACC = await getTeskilatCodesByFilter(tempData?.trnData.BENEFACC, '');
        //     if (dataBENEFACC !== undefined && dataBENEFACC.length > 0) {
        //         setFormFields(old_data => ({
        //             ...old_data,
        //             BENEFBANKCODE: dataBENEFACC[0].code,
        //             BENEFACC: dataBENEFACC[0].orgcode,
        //
        //         }))
        //
        //     }
        // }

        // AMOUNT
        form.setFieldsValue({
            'AMOUNT': checkAmountForRequest(tempData?.trnData.AMOUNT)
        });
        // PMTDET
        form.setFieldsValue({
            'PMTDET': tempData?.trnData.PMTDET.length > 70 ?  tempData?.trnData.PMTDET.substring(0,70)?.trim() : tempData?.trnData.PMTDET?.trim()
        });
        form.setFieldsValue({
            'NOTE': tempData?.trnData.NOTE
        });
        // INFOTOBENEF
        form.setFieldsValue({
            'INFOTOBENEF': tempData?.trnData.INFOTOBENEF
        });
        // COMISSION
        let valueA = checkAmountForRequest(tempData?.trnData.AMOUNT);

        if (!isNaN(valueA)) {
            setCommissionLoading(true);
            setIsDisabled(true)
            const res = await getCustomerCommission({
                PAYMENT_TYPE: "PV",
                CIF: getCurrentCompany().customerNo,
                CUSTACC: findAccount?.IBAN,
                AMOUNT: valueA,
                CUR: findAccount?.CCY_NAME,
                BENEFBANKCODE: tempData?.trnData.BENEFBANKCODE,
                BENEFACC: tempData?.trnData.BENEFACC,
                BENEFTAXID: tempData?.trnData.BENEFTAXID,
                PMTDET: tempData?.trnData.PMTDET.length > 70 ?  tempData?.trnData.PMTDET.substring(0,70) : tempData?.trnData.PMTDET
            })
            if (res !== undefined) {
                setCommissionLoading(false);

                form.setFieldsValue({
                    'COMMAMOUNT': res.COM_AMOUNT ?? ''
                });
                setIsDisabled(false)
                setCommCode(res.CommCode ?? '')
                setCommissionAmount(old_value => res.COM_AMOUNT ?? '')
            }
        } else {
            setCommissionLoading(false);

            form.setFieldsValue({
                'COMMAMOUNT': ''
            });

            setCommissionAmount(old_value => '');
        }

        // BENEFBANKCODE
        form.setFieldsValue({
            'BENEFBANKCODE': tempData?.trnData?.BENEFBANKCODE
        });

        //BENEFNAME

        form.setFieldsValue({
            'BENEFNAME': tempData?.trnData?.BENEFNAME
        });
        form.setFieldsValue({
            'BENEFTAXID': tempData?.trnData?.BENEFTAXID
        });

        // BENEFBANKNAME
        form.setFieldsValue({
            'BENEFBANKNAME': tempData?.trnData?.BENEFBANKNAME
        });
        form.setFieldsValue({
            'BENEFACC':'AZ48CTRE00000000000000014001'
        })
        updateParentComponentFormData()
        setLoadingData(false)
    }
    const updateDocumentNumberAndCommission = (data) => {
        loadDataTemplate(data)
    }

    const resetFormFields = () => {
        form.resetFields(['BENEFNAME','BENEFTAXID'])
        setFormFields(old_data => {});
        setInputValue(old_value => '');
        setInputPlaceholder(old_value => '');
        setAliasStatus(false);
        setStatusLimit('')
        form.resetFields(
            ['document_no']
        )

        setNextModalVisible(false);
        setcustAcc('')
        setCommissionAmount('')
        setRetryRequest(null);
        setFromBranch(undefined)
        // form.resetFields(['showHideEdvBox']);
    }

    const onCloseSuccessModal = () => {
        resetForm(form);
        resetFormFields();
    }



    const checkLimits = async () => {
        setLoadingLimit(true)
        var res = await checkLimit(
            {
                PMTTYPECODE: "PV",
                PMTID: form.getFieldValue('document_no'),
                CREATEDFROMTEMPL: getByTemp,
                TEMPLATE: {
                    TEMPLNAME: tempName
                },
                GETBYALIAS: 'N',
                ALIAS: {
                    ALIASTYPE: '',
                    ALIASVALUE: ''
                },
                CUSTACC: custAcc,
                CUSTACCAVLBALANCE: fromBranch?.BALANCE,
                CUSTACCFORCOM:  form.getFieldValue('COMMAMOUNT'),
                CUSTACCFORCOMCURR: currency,
                BENEFNAME: "Şirvan Onkoloji Xəstəxanası",
                BENEFACC: form.getFieldValue('BENEFACC'),
                BENEFTAXID: form.getFieldValue('BENEFTAXID'),
                BENEFBANKCODE: 210027,
                BENEFBANKNAME: t("newTransfer.stateTreasuryAgencyVAT"),
                BENEFBANKTAXID: bankTaxId,
                BENEFBANKCORACC: bankCorAcc,
                BENEFBANKSWIFT: '',
                PMTAMOUNT: checkAmountForRequest(form.getFieldValue('AMOUNT')),
                COMMAMOUNT: form.getFieldValue('COMMAMOUNT'),
                BUDGETCLASSCODE: '',
                BUDGETCLASSCODENAME: "",
                BUDGETLEVELCODE: '' ,
                BUDGETLEVELCODENAME:  '',
                PMTDET: form.getFieldValue('PMTDET'),
                INFOTOBENEF: form.getFieldValue('INFOTOBENEF'),
                NOTE: form.getFieldValue("NOTE")

            },language
        )
            const temp_array=[];
            const labelArray=[]
            if(res?.LIMITMSGSTAT === 'Success'){
                setStatusLimit('success')
            }else if(res?.LIMITMSGSTAT === 'Failure'){
                setStatusLimit('failure')
                setdisabledSign(true)
            }else if (res?.LIMITMSGSTAT === 'Success' && res?.LIMITS?.keywordRestr ==='Found'){
                setStatusLimit('failure')
            }
            else{
                setStatusLimit('')
            }
            setModalNote(res?.LIMITKWRREMARK !== null ? res?.LIMITKWRREMARK:t("transfers.limitTimeOutError"))
            limitMessage=res?.LIMITKWRREMARK !== null ? res?.LIMITKWRREMARK:t("transfers.limitTimeOutError")
            res?.LIMITS?.limitInfo.split(';').map((row)=>{
                labelArray.push(row.split(':')[0])
                temp_array.push(row.split(':')[1])
            })

            set2ndTitle(labelArray[5])

            setSentCariCount(temp_array[6])
            setTypeTransfer(temp_array[1])
            setCommissionAmountModal(temp_array[3])
            setAmountModal(temp_array[2])
            setAmountTransfer(temp_array[7])
            setCariCount(temp_array[8])
            setCariTotalAmount(temp_array[9])
            setLimitTotalAmount(temp_array[10])
            setLoadingLimit(false)

            return res;

    }

    const cutOff = async() =>{
        setdisabledSign(true)

       var res= await cutOffService({
            PMTTYPECODE: "PV",
            PMTID: form.getFieldValue('document_no'),
            CREATEDFROMTEMPL: getByTemp,
            TEMPLATE: {
                TEMPLNAME: tempName
            },
            GETBYALIAS: 'N',
            ALIAS: {
                ALIASTYPE: '',
                ALIASVALUE: ''
            },
            CUSTACC: custAcc,
            CUSTACCAVLBALANCE: fromBranch?.BALANCE,
            CUSTACCFORCOM: "",
            CUSTACCFORCOMCURR: "",
            BENEFNAME: form.getFieldValue('BENEFNAME'),
            BENEFACC: form.getFieldValue('BENEFACC'),
            BENEFTAXID: form.getFieldValue('BENEFTAXID'),
            BENEFBANKCODE: 210027,
            BENEFBANKNAME: t("newTransfer.stateTreasuryAgencyVAT"),
            BENEFBANKTAXID: bankTaxId,
            BENEFBANKCORACC: bankCorAcc,
            BENEFBANKSWIFT: bankSwift,
            PMTAMOUNT: checkAmountForRequest(form.getFieldValue('AMOUNT')),
            COMMAMOUNT: form.getFieldValue('COMMAMOUNT'),
            BUDGETCLASSCODE: '',
            BUDGETCLASSCODENAME: "",
            BUDGETLEVELCODE:  '',
            BUDGETLEVELCODENAME: '',
            PMTDET: form.getFieldValue('PMTDET'),
            INFOTOBENEF: form.getFieldValue('INFOTOBENEF'),
            NOTE: form.getFieldValue("NOTE")

        },language);
        if(res.CUTOFFMSGSTAT === 'Success' && res.CUTOFF.isWorkingDay ==='Y' && res.CUTOFF.cutoffTime ==='Within'){
            setdisabledSign(false)

            setNextModalNote(res?.CUTOFFREMARK+'<br/>'+modalNote)
            messageCutOff = res?.CUTOFFREMARK+'<br/>'+limitMessage

        } else if(res.CUTOFFMSGSTAT === 'Success' && res.CUTOFF.isWorkingDay ==='Y' && res.CUTOFF.cutoffTime ==='Outof')
        {
            setdisabledSign(false)
            setAlertText(res?.CUTOFFREMARK)
            alertmessage =res?.CUTOFFREMARK
        } else if(res.CUTOFFMSGSTAT === 'Success' && res.CUTOFF.isWorkingDay ==='N' && res.CUTOFF.cutoffTime ==='Outof'){
            setdisabledSign(false)
            setAlertText(res?.CUTOFFREMARK)
            alertmessage=res?.CUTOFFREMARK
        }else if(res.CUTOFFMSGSTAT === 'Failure' ){
            setdisabledSign(true)
            setAlertText(res?.CUTOFFREMARK)
            alertmessage=res?.CUTOFFREMARK
        } else {
            setdisabledSign(true)
            setAlertText(t("transfers.cutOffError"))
            alertmessage=t("transfers.cutOffError")
        }
        setNextModalVisible(old_value => true);
    }

    const checkBenefAcc =async () =>{

        setdisabledSign(true)

       var resp = await benefBankAccCheck({
            PMTTYPECODE: "PV",
            PMTID: form.getFieldValue('document_no'),
            CREATEDFROMTEMPL: getByTemp,
            TEMPLATE: {
                TEMPLNAME: tempName
            },
            GETBYALIAS: getbyAlias,
            ALIAS: {
                ALIASTYPE: '',
                ALIASVALUE: ''
            },
            CUSTACC: custAcc,
            CUSTACCAVLBALANCE: fromBranch?.BALANCE,
            CUSTACCFORCOM:  form.getFieldValue('COMMAMOUNT') ==="---"? 0 : form.getFieldValue('COMMAMOUNT'),
            CUSTACCFORCOMCURR: '',
            BENEFNAME: form.getFieldValue('BENEFNAME'),
            BENEFACC: "AZ48CTRE00000000000000014001",
            BENEFTAXID: form.getFieldValue('BENEFTAXID'),
            BENEFBANKCODE: 210027,
            BENEFBANKNAME: t("newTransfer.stateTreasuryAgencyVAT"),
            BENEFBANKTAXID: bankTaxId,
            BENEFBANKCORACC: bankCorAcc,
            BENEFBANKSWIFT: bankSwift,
            PMTAMOUNT: checkAmountForRequest(form.getFieldValue('AMOUNT')),
            COMMAMOUNT:  form.getFieldValue('COMMAMOUNT') ==="---"? 0 : form.getFieldValue('COMMAMOUNT'),
            BUDGETCLASSCODE:'',
            BUDGETCLASSCODENAME: "",
            BUDGETLEVELCODE:  '',
            BUDGETLEVELCODENAME:  '',
            PMTDET: form.getFieldValue('PMTDET'),
            INFOTOBENEF: form.getFieldValue('INFOTOBENEF'),
            NOTE: form.getFieldValue("NOTE")
        },language)
            if(resp.BENEFMSGSTAT === 'Failure' || resp.BENEFMSGSTAT === null){
                setdisabledSign(true)
                setIsDisabled(true)
                setNextModalVisible(old_value => false);

                setAlertText(resp?.BENEFREMARK)
                alertmessage =resp?.BENEFREMARK

            }else{
                await cutOff()
                setAlertText('')
                setdisabledSign(false)
            }

    }


    const nextModalApi = async() =>{
        const BENEFNAME = form.getFieldValue('BENEFNAME')
        const amount = form.getFieldValue('AMOUNT')
        const PMTDET = form.getFieldValue('PMTDET')
        const BENEFTAXID = form.getFieldValue('BENEFTAXID')


        if( BENEFTAXID !==undefined && BENEFNAME!== undefined   && amount !== undefined && PMTDET !== undefined){

           return await checkLimits()

        }



    }

    const newTransfer = async(RequestType : string, retry : boolean = false) =>{
       if(ibankRef !== "") {
              await   deleteFileById(ibankRef)
              await new Promise(res => setTimeout(res, 1000)); 
             }

        if (!retry) {
            const req ={
                "trnRequestType": RequestType,
                "PMTTYPECODE": "PV",
                "PMTCUSTID": form.getFieldValue("document_no"),
                "PMTID": form.getFieldValue("document_no"),
                "CREATEDFROMTEMPL": getByTemp,
                "TEMPLATE": {
                    "TEMPLNAME": tempName,
                },
                "GETBYALIAS": "N",
                "ALIAS": {
                    "ALIASTYPE": '',
                    "ALIASVALUE": '',
                },
                "CUSTACC": custAcc,
                "CUSTACCTYPE": " ",
                "CUSTACCAVLBALANCE": fromBranch?.BALANCE,
                "CUSTACCBRANCHCODE": '',
                "CUSTACCBRANCHCODECB": "",
                "CUSTACCFORCOM": "",
                "CUSTACCFORCOMCURR": "",
                "BENEFNAME": form.getFieldValue("BENEFNAME"),
                "BENEFACC": "AZ48CTRE00000000000000014001",
                "BENEFTAXID": form.getFieldValue('BENEFTAXID'),
                "BENEFBANKCODE": 210027,
                "BENEFBANKNAME": t("newTransfer.stateTreasuryAgencyVAT"),
                "BENEFBANKTAXID": bankTaxId,
                "BENEFBANKCORACC": bankCorAcc,
                "BENEFBANKSWIFT": '',
                "PMTAMOUNT": form.getFieldValue("AMOUNT"),
                "COMMAMOUNT": form.getFieldValue("COMMAMOUNT"),
                "BUDGETCLASSCODE":'',
                "BUDGETCLASSCODENAME": "",
                "BUDGETLEVELCODE": '',
                "BUDGETLEVELCODENAME": '',
                "PMTDET": form.getFieldValue("PMTDET"),
                "INFOTOBENEF": form.getFieldValue("INFOTOBENEF"),
                "NOTE": form.getFieldValue("NOTE"),
                "CommCode": commCode,
                "ibankRef": ibankRef,
            }
            setRetryRequest(req);
            const data = IpsNewTransfer(req,language);
            return data;
        }else{
            if(retryRequest !== null)
                retryRequest['trnRequestType'] = RequestType;
            const data  = IpsNewTransfer(retryRequest,language);
            return data;
        }
    }

    return (
       <>
           <Row>
               <Col flex={'700px'} className="own-account">
                   <Card bordered={false}>
                       <Row justify='start' className="own-account__form">
                           <Form
                               labelCol={{ flex: '190px'}}
                               wrapperCol={{ flex: 1 }}
                               className='full'
                               onSubmit={(e) => e.preventDefault(e)}
                               onFinish={submitHandler}
                               onValuesChange={updateParentComponentFormData}
                               id={'form'}
                               form={form}
                               autoComplete="off"
                               scrollToFirstError={{
                                behavior: 'smooth',
                                block: 'center',
                                inline: 'center',
                            }}
                           >
                               { !addOrEditPage && <div className='flex ' >
                                   <InputField
                                       labelItem={t("salary.documentNo")}
                                       placeholder={t("salary.automatically")}
                                       name={'document_no'}
                                       required={true}
                                       message={true}
                                       form={form}
                                       maxLength={25}
                                       allowLatinNumber ={true}
                                   />

                                   <Button
                                       size={'large'}
                                       icon={<SaveIco />}
                                       className="blue-button transfer__button flex align_center justify_center create_tr_template_btn"
                                       onClick={e => setTemplatePopupVisible(true)}
                                   >
                                       {OWNACCOUNT.PATTERN}
                                   </Button>
                               </div>
                               }
                               <SelectField
                                   labelItem={t("transfers.fromAccount")}
                                   placeholder={t("accountStatement.chooseAccount")}
                                   options={fromSelectOptions}
                                   name={'CUSTACC'}
                                   value={custAcc}
                                   onChange={getSelectedFromBranch}
                                   required={true}
                                   form={form}
                                   notFoundContent={!loadingAccount ? t("newTransfer.noAccountCorrespondingCurrency") : undefined }
                                   defaultValue={ibanNumber.iban}
                               />

                               <Divider plain orientation="left" className={'tab_divider_left'} >{t("newTransfer.beneficiaryBank")}</Divider>

                               <InputField
                                   labelItem={t("requisites.code")}
                                   placeholder="210027"
                                   allowClear={true}
                                   name={'BENEFBANKCODE'}
                                   className="not-required dark-input isReadOnly"
                                   readOnly={true}
                                   required={false}
                                   maxLength={6}
                                   isNumeric={true}
                                   onlyNumber={true}
                                   form={form}
                                   value={'210027'}
                                   staticValue={true}
                               />

                               <InputField
                                   labelItem={t("requisites.name")}
                                   placeholder={t("newTransfer.stateTreasuryAgencyVAT")}
                                   className="not-required dark-input isReadOnly"
                                   readOnly={!fromBranch?.ACCOUNT_NO}
                                   required={false}
                                   onlyLetter={true}
                                   name = {'BENEFBANKNAME'}
                                   form={form}
                                   value={t("newTransfer.stateTreasuryAgencyVAT")}
                               />

                               <Divider plain orientation="left" className={'tab_divider_left'} >{t("common.beneficiary")}</Divider>
                                <div className={getByTemp==="Y"?'alan_input_box':''}>
                                    <InputField
                                        labelItem={t("requisites.name")}
                                        placeholder={t("newTransfer.nameBeneficiary")}
                                        name={'BENEFNAME'}
                                        required={true}
                                        showCount={true}
                                        maxLength={35}
                                        onlyLetter={true}
                                        readOnly={!fromBranch?.ACCOUNT_NO}
                                        form={form}
                                        className={'isDisabled'}
                                    />
                                </div>


                               <InputField
                                   labelItem={t("deposit.accountNumber")}
                                   placeholder="AZ48CTRE00000000000000014001"
                                   className=" not-required dark-input is_upper_case"
                                   name={'BENEFACC'}
                                   maxLength={'28'}
                                   // onBlur={receiverDetailsbyIban}
                                   value={'AZ48CTRE00000000000000014001'}
                                   form={form}
                                   disabled={true}
                                   staticValue={true}
                               />

                               <InputField
                                   labelItem={t("requisites.taxID")}
                                   placeholder=""
                                   required={true}
                                   isNumeric={true}
                                   onlyNumber={true}
                                   maxLength={'10'}
                                   name={'BENEFTAXID'}
                                   readOnly={!fromBranch?.ACCOUNT_NO}
                                   form={form}
                                   className={'isDisabled'}
                               />

                               <Divider className='no_text' />

                               <div className={'flex relative'}  >
                                   <AmountField
                                       labelItem={t("common.amount")}
                                       placeholder=""
                                       suffix={'AZN'}
                                       name={'AMOUNT'}
                                       className={'amount_and_commission_col amount_input amount_input_width_btn isDisabled'}
                                       required={true}
                                       form={form}
                                       onChange={(e) => debouncedCommission(e.target.value)}
                                       disabled={!fromBranch?.ACCOUNT_NO}
                                   />

                                   <Col className={'commission_col mobile-select'} >
                                       <InputField
                                           labelCol={2}
                                           labelItem={t("home.commission")}
                                           placeholder=""
                                           className="dark-input commission_input commission_input_with_btn isDisabled"
                                           readOnly={true}
                                           suffix="AZN"
                                           customClass={'custom_anipay_spin'}
                                           name={'COMMAMOUNT'}
                                           value={commissionAmount}
                                           hasLoading={commissionLoading}
                                           form={form}
                                       />
                                   </Col>

                                   <Col flex={'72px'} style={{marginLeft : 10}} >
                                       <Button
                                           size={"large"}
                                           className={'blue-button btn flex align_center justify_center'}
                                           disabled={!fromBranch?.ACCOUNT_NO}
                                           onClick={()=>{checkLimits();setlimitModal(true)}}
                                           loading={loadinglimit}
                                       >{t("businessCards.limits")}</Button>
                                   </Col>
                                   {
                                       limitModal && !loadinglimit&&
                                       <LimitsModal
                                           visible={limitModal}
                                           onOk={()=>setlimitModal(false)}
                                           onCancel={()=>setlimitModal(false)}
                                           data={modalDataLimit}
                                           loading={loadinglimit}
                                       />

                                   }
                                   <div className={'flex align_center limit_buttons'} >
                                       {statusLimit !== '' ?

                                           statusLimit === 'success' ?
                                               <Button type={"ghost"} className={'transparent flex align_center justify_center limit_success_ico'} icon={<CheckGreenIco />} /> :
                                               <Button type={"ghost"} className={'transparent flex align_center justify_center limit_cancel_ico'} icon={<CancelRedIco />} /> : <></>

                                       }


                                   </div>
                               </div>


                               <TextAreaField
                                   visible={true}
                                   labelItem={t("accountStatement.paymentDetails")}
                                   placeholder=""
                                   showCount={true}
                                   maxLength={'210'}
                                   name={'PMTDET'}
                                   required={true}
                                   allowDestination={true}
                                   readOnly={!fromBranch?.ACCOUNT_NO}
                                   form={form}
                                   className={'isDisabled'}
                                   allowLatin={true}

                               />

                               <TextAreaField
                                   visible={true}
                                   labelItem={t("transfers.infoForBeneficiary")}
                                   placeholder=""
                                   showCount={true}
                                   maxLength={'560'}
                                   className={'no_required isDisabled'}
                                   readOnly={!fromBranch?.ACCOUNT_NO}
                                   form={form}
                                   allowLatin={true}
                                   name={'INFOTOBENEF'}
                               />

                               <div className={'flex'}>
                                   <Col flex={1}>
                                       <TextAreaField
                                           visible={visible}
                                           className='not-required isDisabled'
                                           labelItem={t("newTransfer.note")}
                                           placeholder={t("newTransfer.notTransferableToBank")}
                                           showCount={true}
                                           form={form}
                                           maxLength={'180'}
                                           name={'NOTE'}
                                           exchangeNote={true}

                                           // allowAllSymboll={true}
                                           readOnly={!fromBranch?.ACCOUNT_NO}
                                       />
                                   </Col>
                                   <Button
                                       className="icon-button add-remove-btn"
                                       icon={visible ? <MinusSmallIco /> : <PlusSmallIco />}
                                       onClick={() => setVisible(!visible)}
                                   />
                               </div>

                               <FileUpload
                                   className='file-upload isDisabled'
                                   labelItem={t("newTransfer.attachPDF")}
                                   form={form}
                                   fileLimit={10}
                                   checkSize={true}
                                   name={'pdf_files'}
                                   onChange={getFileList}
                                   editFileList={fileList}
                                   tempFileList={fileUp}
                                   accept="application/pdf"
                                   multiple={false}
                                   required={false}
                                   removeFile={removeFile}
                                   disabled={!fromBranch?.ACCOUNT_NO}
                               />

                               { !addOrEditPage &&  <div  className='flex button_row' >
                                   <Button
                                       size={'large'}
                                       icon={<SaveBlueIco />}
                                       className="light-button btn save_btn flex align_center justify_center"
                                       htmlType={"button"}
                                       onClick={openSaveAsTemplateModal}
                                   >
                                       {OWNACCOUNT.SAVE}
                                   </Button>

                                   <div className={'flex flex_wrap'}>


                                       <Button
                                           size={'large'}
                                           icon={<RefreshIco />}
                                           className="light-button refresh_btn btn flex align_center justify_center"
                                           onClick={(e) => {resetFormFields(); resetForm(form) }}
                                       >
                                           {t(OWNACCOUNT.REFRESH)}
                                       </Button>

                                       <Button
                                           size={'large'}
                                           htmlType="submit"
                                           className="blue-button next_btn btn flex align_center justify_center"
                                           // onClick={nextModalApi}
                                           disabled={isDisabled}
                                       >
                                           {OWNACCOUNT.NEXT}
                                       </Button>
                                   </div>

                               </div>
                               }
                           </Form>
                       </Row>
                   </Card>
               </Col>
           </Row>

           <NextModal
               errorIcon={<EroorIco />}
               callBackApi={newTransfer}
               visible={nextModalVisible}
               onCloseSuccessModal={onCloseSuccessModal}
               onClose= {() => {setNextModalVisible(false);setRetryRequest(null); }}
               data={modalData}
               className={'no_footer_line'}
               disabled={disabledSign}
               repeatPdfList={fileList}
               currentForm={form}
               transfer={true}
               anipay={true}
               editTransfer={ibankRef !== undefined && ibankRef !== '' && ibankRef !== null}
           />

           <TemplatePopup
               visible={templatePopupVisible}
               onClose={setTemplatePopupVisible}
               trnType={'IPS_VAT'}
               currentForm={form}
            //    setFileList = {setFileUp}
               updateAfterTemplate={updateDocumentNumberAndCommission}
           />

           <SaveAsTemplate
               visible={saveAsTemplatePopupVisible}
               onClose={setSaveAsTemplatePopupVisible}
               trnType={'IPS_VAT'}
               currentForm={form}
           />
           {
               loadingData ? <FullScreenLoading /> : <></>
           }
       </>
    )
}

const mapDispatchToProps = {setIbanNumber}

const mapStateToProps = (state: any,ownProps:any) => ({
    ownProps:ownProps,
    ibanNumber: (state.accountsStatement && state.accountsStatement.ibanNumber) ? state.accountsStatement.ibanNumber : {}
});

export default connect(mapStateToProps, mapDispatchToProps)(Edv)
